


































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import UserCard from "@/components/UserCard.vue";
import store from "@/store";
import VueRecaptcha from "vue-recaptcha";

declare var grecaptcha: any;

@Component({
	components: {
		UserCard,
		VueRecaptcha,
	},
})
export default class App extends Vue {
	public drawer: boolean = false;
	@Prop() public source!: string;

	public captcha: string | null = null;
	// private readonly recaptchaApiKey = "6LexMqQZAAAAAOrq9SNMVzEBEPTB4kYXOlWr1ZrB"; // localhost
	private readonly recaptchaApiKey = "6LegMqQZAAAAAMG2VVUZbMhiUO7JvQxDN31n5ALN";

	private readonly links: { [name: string]: string} = {
		mail: "mailto:reg@lakesidefurs.at",
		tg: "https://t.me/joinchat/SSgKIXfkEFhr9eQi",
		tg_info: "https://t.me/LSFInfo",
		discord: "https://discord.gg/5gsRYXu",
	};

	constructor() {
		super();
	}

	public get locale() {
		return store.state.locale;
	}
	public get userIsAdmin() {
		return store.state.user && store.state.user.admin;
	}

	public openProtectedLink(name: string) {
		const link = this.links[name];
		grecaptcha.execute();
		const fnRetry = (i: number) => {
			if (this.captcha !== null)
				window.open(link);
			else if (i >= 0)
				return setTimeout(() => fnRetry(i - 1), 500);
			else
				(window as any).___captcha_callback = () => {
					(window as any).___captcha_callback = undefined;
					fnRetry(3);
				};
		};
		fnRetry(3);
	}

	public switchLocale() {
		store.commit("switchLocale");
		this.$vuetify.lang.current = store.state.locale;
		setTimeout(() => {
			window.location.reload();
		}, 250);
	}

	private onRecaptchaVerify(response: string) {
		this.captcha = response || null;
		(window as any).___captcha = response;
		if ((window as any).___captcha_callback)
			(window as any).___captcha_callback();
	}
	private onRecaptchaExpired() {
		this.captcha = null;
		(window as any).___captcha = null;
	}
}
